import angular = require('angular');
import _ = require('underscore');
import { StoreInventoryListItem } from '../../../core';

class ChooseCategoryModalInstanceController {
    modalInstance: ng.ui.bootstrap.IModalServiceInstance = <any>this;
    resolve: {
        categories: StoreInventoryListItem[]
    };
    categories: StoreInventoryListItem[] = [];

    pagination = {
        data: [],
        page: 1,
        pageSize: 10,
        total: 0,
        filter: '',
        setDefault: () => {
            let i = this.pagination;
            i.page = 1;
            i.filter = '';
        },
        setData: () => {
            let i = this.pagination;
            var filtered = i.applyFilter();
            i.total = _.size(filtered);
            i.data = filtered.slice(i.pageSize * (i.page - 1), i.pageSize * i.page);
        },
        applyFilter: (): StoreInventoryListItem[] => {
            var i = this.pagination;
            var keyword = i.filter.trim();
            var regex = new RegExp('\\b' + keyword + '.*', 'i');
            if (i.filter.trim()) {
                return _.filter(this.categories, (category) => {
                    return regex.test(category.CategoryFullName);
                });
            } else {
                return this.categories;
            }
        },
    };

    $onInit() {
        this.categories = this.resolve.categories || [];
        this.pagination.setData();
    }

    ok(category: any) {
        this.modalInstance.close({ $value: category });
    }

    cancel() {
        this.modalInstance.dismiss({ $value: 'cancel' });
    }
}

angular.module('naut').component('chooseCategory', {
    template: require('./chooseCategory.html'),
    controller: ChooseCategoryModalInstanceController,
    controllerAs: 'vm',
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/inventory/components/chooseCategory/chooseCategory.component.ts